import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { FC } from 'react';

export interface ILoseUpdatesModalProps {
  open: boolean;
  onCloseLoseUpdates: () => void;
  onContinueLoseUpdates: () => void;
}

export const LoseUpdatesModal: FC<ILoseUpdatesModalProps> = ({
  open,
  onCloseLoseUpdates,
  onContinueLoseUpdates
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCloseLoseUpdates}
    >
      <DialogContent sx={{ p: 2 }}>
        <Typography
          sx={{ color: 'black', fontWeight: 'bold', mb: 1 }}
        >
          You will lose all of your updates!
        </Typography>
        <Typography sx={{ color: 'black', mb: 1 }}>You haven't submitted your changes yet.</Typography>
        <Typography sx={{ color: 'black' }}>Are you sure you want to select another Shift?</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ fontWeight: 'bold' }}
          variant='text'
          onClick={onCloseLoseUpdates}
        >
          Cancel
        </Button>
        <Button sx={{ fontWeight: 'bold' }} variant='text' onClick={onContinueLoseUpdates}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}